import React from 'react';
import { useUserData, FrequencyOption } from '@/context/UserDataContext';
import { getDairyFrequencyOptions } from '../../shared/constants';
import { FormSection } from '../../shared/FormSection';
import AnimatedSelectionGroup from '../../AnimatedSelectionGroup';

interface DairyConsumptionProps {
  error?: string;
  onComplete?: () => void;
}

const DairyConsumption: React.FC<DairyConsumptionProps> = ({ error, onComplete }) => {
  const { userData, setUserData } = useUserData();
  const dairyOptions = getDairyFrequencyOptions();

  const handleDairyConsumptionChange = (value: FrequencyOption) => {
    setUserData(prev => ({ ...prev, dairyConsumption: value }));
  };

  return (
    <FormSection
      question="How often do you consume dairy products?"
      helperText="This helps us assess things like your calcium and vitamin D intake."
      error={error}
    >
      <AnimatedSelectionGroup
        options={dairyOptions}
        value={userData.dairyConsumption}
        onChange={handleDairyConsumptionChange}
        name="dairy-consumption"
        onComplete={onComplete}
      />
    </FormSection>
  );
};

export default DairyConsumption; 